<template>
  <span class="icon" @click="$emit('click')" :key="Math.random()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :class="[{ 'icon-animation-pulse': !exists }, classes, 'zondicon']"
      :data-name="icon"
      viewBox="0 0 20 20"
      :style="{
        height: `${size}em`,
        width: `${size}em`,
      }"
      fill="currentColor"
      role="img"
      aria-hidden="true"
      v-html="content"
    ></svg>
  </span>
</template>

<script>
import * as icons from '@/mixins/icons'
import * as computed from '@/mixins/computed'
import { question } from '@/utils/icons/zondicons'

export default {

  inheritAttrs: false,

  mixins: [
    icons.shared,
    icons.zondicons,
    computed.usesIconLibraries
  ],

  data: () => ({
    useLibrary: 'zondicons',
    fallback: question
  }),

}
</script>
